<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item>外教招聘</Breadcrumb-item>
        <Breadcrumb-item>待审核老师</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search" @keyup.enter="search">
      <Form :label-width="100" :show-message="false" label-position="right">
        <Row :gutter="32">
          <Col :span="6">
            <Form-item label="类型">
              <Select v-model.number="queryParam.category" placeholder="全部"
                      @on-change="search" clearable>
                <Option v-for="item in teacherCategoryList"
                        :value="item.code" :key="item.code">{{ item.text }}
                </Option>
              </Select>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="操作人昵称">
              <Input name="adminNickname" placeholder="支持模糊搜索"
                     v-model="queryParam.adminNickname"></Input>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="操作人邮箱">
              <Input name="adminMobile" placeholder="支持模糊搜索"
                     v-model="queryParam.adminMobile"></Input>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="状态">
              <Select v-model.number="queryParam.status" placeholder="全部"
                      @on-change="search" clearable>
                <!-- 只展示 code 为 -1, 0, 2 的选项 -->
                <Option v-for="item in filteredTeacherStatus"
                        :value="item.code" :key="item.code">{{ item.text }}
                </Option>
              </Select>
            </Form-item>
          </Col>

          <Col :span="6">
            <Form-item label="老师ID" prop="id">
              <Input name="id" v-model="queryParam.id"></Input>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="老师昵称">
              <Input name="name" placeholder="支持模糊搜索"
                     v-model="queryParam.name"></Input>
            </Form-item>
          </Col>
          <i-col :xs="4">
            <Form-item label="邀请人">
              <Input name="inviteTchName" placeholder="支持模糊搜索"
                     v-model="queryParam.inviteTchName"></Input>
            </Form-item>
          </i-col>
          <Col :span="6">
            <Form-item label="老师账号">
              <Input name="account" placeholder="支持模糊搜索"
                     v-model="queryParam.account"></Input>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="老师国籍">
              <Input name="account" placeholder="支持模糊搜索"
                     v-model="queryParam.country"></Input>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="老师口音">
              <Select v-model.number="queryParam.accent" placeholder="全部"
                      @on-change="search" clearable>
                <Option value="1">英音</Option>
                <Option value="2">美音</Option>
                <Option value="9">其他</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="老师性别">
              <Select v-model.number="queryParam.sex" placeholder="全部"
                      @on-change="search" clearable>
                <Option value="1">男</Option>
                <Option value="2">女</Option>
              </Select>
            </Form-item>
          </Col>
          <i-col :span="6">
            <Form-item label="来源：">
              <Select v-model.number="queryParam.channel" placeholder="全部"
                      @on-change="search" clearable>
                <Option v-for="item in $constant.tchChannel"
                        :value="item.code" :key="item.code">{{ item.text }}
                </Option>
              </Select>
            </Form-item>
          </i-col>
          <Col :span="6">
            <Form-item label="注册渠道">
              <Select v-model="queryParam.regFrom" placeholder="全部" clearable @on-change="search">
                <Option v-for="item in channelOptions" :value="item.param" :key="item.id">{{ item.status === 0 ? (item.name + '（停用）') : item.name }}</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="种族">
              <Select v-model="queryParam.ethnicity" placeholder="全部"
                      @on-change="search" clearable>
                <Option value="African">African</Option>
                <Option value="Coloured">Coloured</Option>
                <Option value="White">White</Option>
                <Option value="Indian/Asian">Indian/Asian</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :span="6">
            <Form-item label="注册时间">
              <DatePicker @on-change="createDateChange" format="yyyy-MM-dd" type="daterange"
                          clearable placement="bottom-start" placeholder="" style="width: 100%"></DatePicker>
            </Form-item>
          </Col>
          <Col :span="6">
            <Button type="primary" :loading="searchLoading" :disable="searchLoading" icon="search"
                    @click="search">搜索
            </Button>
          </Col>
        </Row>
      </Form>
    </div>
    <div class="btn-wrap">
      <Row>
        <Col>
          <Button type="primary" icon="plus-round" @click="onInsertTch">添加老师</Button>
          <Button type="primary" @click="showBatchReview">批量审核</Button>
        </Col>
      </Row>
    </div>
    <List ref="dataList" :tableColumns="title" :reload="reload" :reloadWithPage="reloadWithPage" listUrl="/tch/unaudited/list"
          :params="queryParam" :onLoading="onLoading" operator="" @on-selection-change="selectionChange"></List>
    <Modal width="800"
           v-model="showTchChangeModal"
           title="操作记录">
      <Table :columns="tchChangeStatusColumn" :data="tchChangeStatusList"></Table>
      <div slot="footer"></div>
    </Modal>

    <Modal title="审核通过" v-model="showPassModal">
      <Form ref="passForm" class="form"
            :model="passParam" :rules="passRule"
            :label-width="80">
        <Row>
          <Col :span="22">
            <Form-item style="margin-bottom: 10px">
              <label>确定允许 <b>{{ passParam.id }} - {{ passParam.firstName }} {{ passParam.lastName }}</b>
                老师通过审核，进入培训中</label>
            </Form-item>
          </Col>
          <Col :span="22">
            <Form-item label="理由" prop="remark">
              <Input type="textarea" :autosize="{minRows: 2,maxRows: 3}" :maxlength="100"
                     placeholder="长度不要超过100个字"
                     v-model="passParam.remark"></Input>
            </Form-item>
          </Col>
        </Row>
      </Form>
      <div slot="footer">
        <Button type="text" size="large" @click="showPassModal=false">取消</Button>
        <Button type="primary" size="large" :loading="loadingPass" @click="pass">通过</Button>
      </div>
    </Modal>

    <Modal title="审核拒绝" v-model="showRejectModal">
      <Form ref="rejectForm" class="form"
            :model="rejectParam" :rules="rejectRule"
            :label-width="80">
        <Row>
          <Col :span="22">
            <Form-item style="margin-bottom: 10px">
              <label>确定 <b>{{ rejectParam.id }} - {{ rejectParam.firstName }} {{ rejectParam.lastName }}</b> 老师未审核通过</label>
            </Form-item>
          </Col>
          <Col :span="22">
            <Form-item label="理由" prop="remark">
              <Input type="textarea" :autosize="{minRows: 2,maxRows: 3}" :maxlength="100"
                     placeholder="长度不要超过100个字"
                     v-model="rejectParam.remark"></Input>
            </Form-item>
          </Col>
        </Row>
      </Form>
      <div slot="footer">
        <Button type="text" size="large" @click="showRejectModal=false">取消</Button>
        <Button type="error" size="large" :loading="loadingReject" @click="reject">拒绝</Button>
      </div>
    </Modal>

    <Modal title="批量审核" v-model="showBatchReviewModal">
      <Form ref="reviewForm" class="form" :model="reviewParam" :rules="rejectRule" :label-width="90">
        <Row>
          <Col :span="22">
            <Form-item label="待审核老师：">
              <Tag v-for="item in selectionTch" :key="item.id" :name="item.id">
                {{ item.id + ' - ' + item.firstName + ' ' + item.lastName }}
              </Tag>
            </Form-item>
          </Col>
          <Col :span="22">
            <Form-item label="理由：" prop="remark">
              <Input type="textarea" :autosize="{minRows: 2,maxRows: 3}" :maxlength="100"
                     placeholder="长度不要超过100个字"
                     v-model="reviewParam.remark"></Input>
            </Form-item>
          </Col>
        </Row>
      </Form>
      <div slot="footer">
        <Button type="primary" size="large" @click="batchReview('batchPass')">通过</Button>
        <Button type="primary" size="large" @click="batchReview('batchReject')">拒绝</Button>
      </div>
    </Modal>
    <tch-info-modal :value="showTchInfoModal" @on-close="showTchInfoModal=false" :tchId="tchId" :showTchSelf="true" :successCallback="search" recruit-flow-entry="待审核老师列表"></tch-info-modal>
    <send-email-modal :visible="showEmailModal" @on-close="showEmailModal=false" :tchId="emailTchId" :tchName="emailTchName" :successCallback="search"></send-email-modal>
    <tch-apply-form-modal :visible="showApplyModal" @on-close="showApplyModal=false" :tchId="applyTchId"></tch-apply-form-modal>
  </div>
</template>
<script>

import TchInfoModal from './modal/TchInfoModal.vue'
import { fetchTchScoreMap, applyTchScoresToRows, renderTchNameWithScore } from '@/utils/tchScore'
import SendEmailModal from './modal/SendEmailModal.vue'
import TchApplyFormModal from './modal/TchApplyFormModal.vue'

export default {
  components: {TchInfoModal, SendEmailModal, TchApplyFormModal},
  data () {
    let $constant = this.$constant
    let $moment = this.$moment
    return {
      searchLoading: false,
      rankScoreSeq: 0,
      reload: 0,
      reloadWithPage: 0,
      showTchInfoModal: false,
      queryParam: {
        country: '',
        accent: '',
        sex: '',
        channel: '',
        inviteTchName: '',
        regFrom: '',
        ethnicity: '',
        uid: '',
        mobile: '',
        nickname: '',
        startTimeDate: '',
        endTimeDate: '',
        status: 0,
        startCreateDate: '',
        endCreateDate: ''
      },
      channelOptions: [],
      teacherCategoryList: [{code: 2, text: '正式老师'}, {code: 1, text: '试用期老师'}, {code: 3, text: '工作人员'}],

      // 审核通过
      showPassModal: false,
      loadingPass: false,
      passParam: {
        remark: ''
      },
      passRule: {
        remark: [
          {type: 'string', required: true, message: '理由不能为空', trigger: 'blur'},
          {type: 'string', max: 100, message: '理由不能超过100个字', trigger: 'blur'}
        ],
      },
      // 审核拒绝
      showRejectModal: false,
      loadingReject: false,
      rejectParam: {
        id: '',
        remark: ''
      },
      rejectRule: {
        remark: [
          {type: 'string', required: true, message: '理由不能为空', trigger: 'blur'},
          {type: 'string', max: 100, message: '理由不能超过100个字', trigger: 'blur'}
        ],
      },
      // 发送邮件
      showEmailModal: false,
      emailTchId: null,
      emailTchName: '',
      showApplyModal: false,
      applyTchId: null,
      showInsertTchModal: false,
      tchId: null,
      showUpdateTchModal: false,
      // 操作记录
      showTchChangeModal: false,
      tchChangeStatusList: [],
      tchChangeStatusColumn: [
        {
          title: '修改类别',
          render: (h, params) => {
            let type = params.row.type
            let typeEnum = $constant.getEnum($constant.tchChangeStatusType, type)
            return h('span', typeEnum && typeEnum.text)
          }
        },
        {
          title: '原来状态',
          render: (h, params) => {
            let row = params.row
            let oldStatus = row.oldStatus
            let type = row.type
            if (type === 1) {
              let oldStatusEnum = $constant.getEnum($constant.teacherStatus, oldStatus)
              return h('span', oldStatusEnum && oldStatusEnum.text)
            } else if (type === 4) {
              return h('span', row.oldNickname || '')
            }
            return h('span', oldStatus)
          }
        },
        {
          title: '现在状态',
          render: (h, params) => {
            let row = params.row
            let newStatus = row.newStatus
            let type = row.type
            if (type === 1) {
              let newStatusEnum = $constant.getEnum($constant.teacherStatus, newStatus)
              return h('span', newStatusEnum && newStatusEnum.text)
            } else if (type === 4) {
              return h('span', row.newNickname || '')
            }
            return h('span', newStatus)
          }
        },
        {
          title: '操作人',
          key: 'adminNickname'
        },
        {
          title: '操作时间',
          width: 170,
          render: (h, params) => {
            let createTime = params.row.createTime
            return h('span', createTime && $moment(createTime, 'X').format('YYYY-MM-DD HH:mm:ss'))
          }
        },
        {
          title: '理由',
          key: 'remark'
        }
      ],
      selectionTch: [],
      showBatchReviewModal: false,
      reviewParam: {
        ids: '',
        remark: ''
      },
      title: [
        {
          type: 'selection',
          width: 60,
          align: 'center'
        },
        {
          title: '老师ID',
          width: 80,
          align: 'center',
          key: 'id'
        },
        {
          title: '老师昵称',
          width: 160,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            return renderTchNameWithScore(h, {
              text: (row.firstName || '') + ' ' + (row.lastName || ''),
              score: row.monthRankScore,
              onClick: () => this.openTchInfoModal(row.id)
            })
          }
        },
        {
          title: 'Full Name',
          width: 120,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            return h('a', {on: {click: () => this.openTchInfoModal(row.id)}}, row.fullName)
          }
        },
        {
          title: '老师账号',
          key: 'account',
          width: 130,
          align: 'center',
        },
        {
          title: '推荐人',
          width: 180,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            return h('Input', {
              props: {
                value: row.inviteTchName || '',
                placeholder: '输入推荐人ID'
              },
              style: { width: '160px' },
              on: {
                'on-blur': (event) => {
                  const newValue = event.target.value
                  if (newValue !== (row.inviteTchName || '')) {
                    row.inviteTchName = newValue
                    this.updateInviteTch(row, newValue)
                  }
                },
                'on-enter': (event) => {
                  const val = event.target ? event.target.value : event
                  if (val !== (row.inviteTchName || '')) {
                    row.inviteTchName = val
                    this.updateInviteTch(row, val)
                  }
                }
              }
            })
          }
        },
        {
          title: '注册时间',
          width: 150,
          align: 'center',
          render: (h, params) => {
            let createTime = params.row.createTime
            return h('span', createTime && $moment(createTime, 'X').format('YYYY-MM-DD HH:mm'))
          }
        },
        {
          title: '现居地',
          width: 150,
          align: 'center',
          key: 'country'
        },
        {
          title: '种族',
          width: 130,
          align: 'center',
          render: (h, params) => {
            let row = params.row
            return h('Select', {
              props: {
                value: row.ethnicity,
                transfer: true
              },
              on: {
                'on-change': (value) => {
                  row.ethnicity = value
                  this.updateTchDirect({tchForm: {tchId: row.id, ethnicity: value}})
                }
              }
            }, [
              h('Option', {props: {value: 'African'}}, 'African'),
              h('Option', {props: {value: 'Coloured'}}, 'Coloured'),
              h('Option', {props: {value: 'White'}}, 'White'),
              h('Option', {props: {value: 'Indian/Asian'}}, 'Indian/Asian')
            ])
          }
        },
        {
          title: '注册渠道',
          width: 120,
          align: 'center',
          key: 'regFrom'
        },
        {
          title: '类型',
          width: 100,
          align: 'center',
          render: (h, params) => {
            let category = params.row.category
            let categoryEnum = $constant.getEnum($constant.teacherCategory, category)
            return h('span', categoryEnum && categoryEnum.text)
          }
        },
        {
          title: '状态',
          width: 100,
          align: 'center',
          render: (h, params) => {
            let status = params.row.status
            let statusEnum = $constant.getEnum($constant.teacherStatus, status)
            return h('span', statusEnum && statusEnum.text)
          }
        },
        {
          title: '来源',
          width: 100,
          align: 'center',
          render: (h, params) => {
            let tchChannel = params.row.channel
            let tchChannelEnum = $constant.getEnum($constant.tchChannel, tchChannel)
            return h('div', tchChannelEnum && tchChannelEnum.text)
          }
        },
        {
          title: '最近跟踪',
          width: 170,
          align: 'center',
          render: (h, params) => {
            let trackTime = params.row.trackTime
            let trackContent = params.row.trackContent
            return h('div', [
              h('div', {
                attrs: {
                  title: trackContent // 鼠标悬停时显示完整内容
                },
                style: {
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap'
                }
              }, trackContent || ''),
              h('div', {
                style: {
                  fontSize: '12px',
                  color: '#999',
                  marginTop: '4px'
                }
              }, trackTime || '')
            ])
          }
        },
        {
          title: '操作日志',
          width: 100,
          align: 'center',
          render: (h, params) => {
            let self = this
            let isTchChange = params.row.isTchChange
            let id = params.row.id
            if (isTchChange) {
              return h('a', {
                on: {
                  click: () => {
                    self.onTchChangeStatusList(id)
                  }
                }
              }, '查看')
            } else {
              return h('span', '无记录')
            }
          }
        },
        {
          title: '操作',
          width: 220,
          fixed: 'right',
          align: 'center',
          render: (h, params) => {
            let row = params.row
            let operationArr = []
            if (row.applyStep !== null && row.applyStep !== undefined && row.applyStep !== '') {
              operationArr.push(h('a', {
                on: {
                  click: () => {
                    this.onShowApply(row)
                  }
                }
              }, '注册资料'))
              operationArr.push(h('span', {class: 'divider'}))
            }
            operationArr.push(h('a', {
              on: {
                click: () => {
                  this.onPass(row)
                }
              }
            }, '通过'))
            if (row.status === 0) {
              operationArr.push(h('span', {class: 'divider'}))
              operationArr.push(h('a', {
                on: {
                  click: () => {
                    this.onReject(row)
                  }
                }
              }, '拒绝'))
            }
            operationArr.push(h('span', {class: 'divider'}))
            operationArr.push(h('a', {on: { click: () => { this.onSendEmail(row) } }}, '发送邮件'))
            return h('div', operationArr)
          }
        }
      ]
    }
  },
  mounted: function () {
  },
  created: function () {
    this.loadRegChannels()
  },
  computed: {
    filteredTeacherStatus () {
      const allowedCodes = [-1, 0, 2]
      return this.$constant.teacherStatus.filter(item => allowedCodes.includes(item.code))
    }
  },
  methods: {
    openTchInfoModal (val) {
      this.tchId = val
      this.showTchInfoModal = true
    },
    search () {
      this.reload = new Date().getTime()
    },
    createDateChange (value) {
      this.queryParam.startCreateDate = (value && value[0]) || ''
      this.queryParam.endCreateDate = (value && value[1]) || ''
      this.search()
    },
    searchWithPage () {
      this.reloadWithPage = new Date().getTime()
    },
    loadRegChannels () {
      let self = this
      this.$http.get('/tch/reg-channel/options').then(function (res) {
        if (res && res.status === 'ok' && res.data) {
          self.channelOptions = res.data
        }
      })
    },
    onLoading (loading) {
      this.searchLoading = loading
    if (!loading) {
      this.loadMonthRankScores()
    }
    },
    loadMonthRankScores () {
      const table = this.$refs.dataList && this.$refs.dataList.tableData
      if (!table || !table.length) {
        return
      }
      const ids = table.map(function (row) { return row.id }).filter(function (id) { return id != null })
      const seq = ++this.rankScoreSeq
      const self = this
      fetchTchScoreMap(this.$http, ids).then(function (map) {
        if (seq !== self.rankScoreSeq) {
          return
        }
        applyTchScoresToRows(self, table, 'id', 'monthRankScore', map)
      })
    },
    onPass (row) {
      // if (!row.ethnicity) {
      //   this.$Message.warning('请先在"种族"列选择种族后再审核通过')
      //   return
      // }
      this.showPassModal = true
      this.passParam.id = row.id
      this.passParam.firstName = row.firstName
      this.passParam.lastName = row.lastName
      this.passParam.remark = ''
    },
    pass () {
      let self = this
      self.loadingPass = true
      self.$refs.passForm.validate((valid) => {
        if (!valid) {
          self.$Message.warning('信息输入错误!')
          self.loadingPass = false
          return
        }
        let params = {}
        params.id = self.passParam.id
        params.remark = self.passParam.remark
        self.$http.post('/tch/pass', params).then(function (res) {
          if (res && res.data > 0) {
            self.searchWithPage()
            self.showPassModal = false
          }
          self.loadingPass = false
        }).catch(function (e) {
          self.showPassModal = false
          self.loadingPass = false
        })
      })
    },
    onReject (row) {
      this.showRejectModal = true
      this.rejectParam.id = row.id
      this.rejectParam.firstName = row.firstName
      this.rejectParam.lastName = row.lastName
      this.passParam.remark = ''
    },
    reject () {
      let self = this
      self.loadingReject = true
      self.$refs.rejectForm.validate((valid) => {
        if (!valid) {
          self.$Message.warning('信息输入错误!')
          self.loadingReject = false
          return
        }
        let params = {}
        params.id = self.rejectParam.id
        params.remark = self.rejectParam.remark
        self.$http.post('/tch/reject', params).then(function (res) {
          if (res && res.data > 0) {
            self.searchWithPage()
            self.showRejectModal = false
          }
          self.loadingReject = false
        }).catch(function (e) {
          self.showRejectModal = false
          self.loadingReject = false
        })
      })
    },
    onInsertTch () {
//        this.showInsertTchModal = true
      this.showTchInfoModal = true
      this.tchId = null
    },
//      onUpdateTch (row) {
//        this.showUpdateTchModal = true
//        this.tchId = row.id
//      },
    onTchChangeStatusList (tchId) {
      let self = this
      self.tchChangeStatusList = []
      self.$http.get('/tchChangeStatus/listByCondition?tchId=' + tchId).then(function (res) {
        self.showTchChangeModal = true
        if (!res || !res.data) {
          return
        }
        self.tchChangeStatusList = res.data
      })
    },
    selectionChange (selection) {
      this.selectionTch = selection
    },
    showBatchReview () {
      if (this.selectionTch.length <= 0) {
        this.$Message.warning('请选择待审核老师！')
        return
      }
      this.showBatchReviewModal = true
    },
    batchReview (val) { // 批量审核
      let self = this
      self.$refs.reviewForm.validate((valid) => {
        if (!valid) {
          return
        }
        let idList = self.selectionTch.map(function (element) {
          return element.id
        })
        self.reviewParam.ids = idList.join(',')
        let path = '/tch/' + val
        self.$http.post(path, self.reviewParam).then(function (res) {
          self.$Message.success('审核成功')
          self.showBatchReviewModal = false
          self.selectionTch = []
          self.searchWithPage()
        }).catch(function (e) {
          self.$Message.error('审核失败')
          self.showBatchReviewModal = false
          self.selectionTch = []
          self.searchWithPage()
        })
      })
    },
    onShowApply (row) {
      this.applyTchId = row.id
      this.showApplyModal = true
    },
    onSendEmail (row) {
      this.emailTchId = row.id
      this.emailTchName = row.firstName + ' ' + row.lastName
      this.showEmailModal = true
    },
    updateTchDirect (req) {
      this.$http.post('/tch/update-direct', req).then(res => {
        if (res.status === 'ok') {
          this.$Message.success('更新成功')
        } else {
          this.$Message.error(res.msg)
        }
      }).catch(() => {
        this.$Message.error('更新失败')
      })
    },
    updateInviteTch (row, val) {
      const inviteId = parseInt(val)
      if (!inviteId || inviteId <= 0) {
        this.$Message.warning('请输入有效的推荐人ID')
        return
      }
      this.$http.post('/tch/update-referrer', { newTchId: row.id, inviteId: inviteId }).then(res => {
        if (res.status === 'ok') {
          this.$Message.success('推荐人更新成功')
          this.searchWithPage()
        } else {
          this.$Message.error(res.msg || '更新失败')
        }
      }).catch(() => {
        this.$Message.error('更新失败')
      })
    },
  }
}
</script>

<style lang="less" scoped>
.btn-wrap {
  text-align: right;
  margin-top: 24px;
  margin-bottom: 12px;
}
</style>



// WEBPACK FOOTER //
// TchUnauditedList.vue?09b85a1e